module.exports = __webpack_public_path__ + "img/inverted.bcbeb85f.svg";